import { DelaysSankeyReportPage } from "./DelaysSankeyReportPage";

type Props = {};
const DelaysSankeyReport = (props: Props) => {
	return <DelaysSankeyReportPage />;
};
export default DelaysSankeyReport;
